<template>
  <header id="header">
    <div class="float-right">
      <I18n />
    </div>
    <h1>
      <router-link
        :to="`/${$t('lang')}/`"
        class="text-decoration-none"
        v-html="$t('color.games')"
      />
    </h1>
    <p
      class="lead"
      v-html="$t('meta.lead')"
    ></p>
    <hr
      class="trait"
      role="presentation"
    />
  </header>
</template>

<script>
import I18n from '../../commons/components/I18n.vue';

export default {
  components: {
    I18n,
  },
};
</script>

<style lang="scss">
  #header {
    background: #fff;
    // border-bottom: 1px solid var(--f-g4);

    h1 {
      margin: 0;
      line-height: normal;
      a {
        text-decoration: none;
      }
    }

    .btn {
      border: transparent;
    }
  }
</style>
